<template>
    <div>
        <div class="step-title text-center">
            {{ $trans('storefront::flexible_packaging.what_type_of_pouch_would_you_like') }}
        </div>

        <div class="spacer-56"></div>

        <div class="step-title fs-2 text-center">
            {{ $trans('storefront::flexible_packaging.lay_flat_pouch') }}
        </div>

        <div class="spacer-48"></div>

        <div class="container">
            <div class="d-flex flex-wrap justify-content-center gap-40">
                <template v-for="(item, index) in items">
                    <flexible-packaging-option
                        v-if="index !== 4"
                        :active="store.data.pouchType === item.title"
                        :icon="$getImg(item.imgSrc)"
                        :title="$trans(`storefront::flexible_packaging.${item.title}`)"
                        :description="item.description"
                        @click.native="handleClick(item.title, item.sizeComponent)"
                    ></flexible-packaging-option>
                </template>
            </div>

            <div class="spacer-72"></div>

            <div class="step-title fs-2 text-center">
                {{ $trans('storefront::flexible_packaging.side_gusset_pouch') }}
            </div>

            <div class="spacer-48"></div>
            <div class="d-flex flex-wrap justify-content-center gap-40">
                <flexible-packaging-option
                    :active="store.data.pouchType === items[4].title"
                    :icon="$getImg(items[4].imgSrc)"
                    :title="$trans(`storefront::flexible_packaging.${items[4].title}`)"
                    :description="items[4].description"
                    @click.native="handleClick(items[4].title, items[4].sizeComponent)"
                ></flexible-packaging-option>
            </div>
        </div>
    </div>
</template>

<script>
import {useFlexiblePackagingStore} from "../../js/store";
import FlexiblePackagingOption from "../inc/FlexiblePackagingOption";

export default {
    components: {FlexiblePackagingOption},
    setup() {
        const store = useFlexiblePackagingStore();
        return {
            store: store,
        }
    },
    data() {
        return {
            items: [
                {
                    imgSrc: 'flexible-packaging/pouches/2-side-seal-pouch@2x.png',
                    title: '2_side_seal_pouch',
                    description: 'Lay flat or “pillow” pouch sealed on 2 sides.',
                    sizeComponent: 'SidePlowSizeSelector',
                },
                {
                    imgSrc: 'flexible-packaging/pouches/3-side-seal-pouch@2x.png',
                    title: '3_side_seal_pouch',
                    description: 'Lay flat or “pillow” pouch sealed on 3 sides.',
                    sizeComponent: 'SidePlowSizeSelector',
                },
                {
                    imgSrc: 'flexible-packaging/pouches/plow-bottom-pouch@2x.png',
                    title: 'plow_bottom_pouch',
                    description: 'Plow-like appearance when standing upright.',
                    sizeComponent: 'PlowSizeSelector',
                },
                {
                    imgSrc: 'flexible-packaging/pouches/skirt-seal-pouch@2x.png',
                    title: 'skirt_seal_pouch',
                    description: 'Bottom seal that extends to create “skirt” around bottom.',
                    sizeComponent: 'PlowSizeSelector',
                },
                {
                    imgSrc: 'flexible-packaging/pouches/quad-seal-pouch@2x.png',
                    title: 'quad_seal_pouch',
                    description: '2 vertical panels and 2 side gussets sealed together.',
                    sizeComponent: 'QuadSizeSelector',
                },
            ]
        };
    },
    methods: {
        handleClick(value, component) {
            let oldValue = this.store.data.pouchType;
            this.store.data.pouchType = value;
            this.store.changeComponentByType('pouch_size', component);
            this.store.nextStep();

            if (oldValue === this.store.data.pouchType) return;
            switch (this.store.data.pouchType) {
                case "2_side_seal_pouch":
                case "3_side_seal_pouch":
                    this.store.data.pouch_size = '2.5" x 7"';
                    break;
                case "plow_bottom_pouch":
                case "skirt_seal_pouch":
                    this.store.data.pouch_size = '3.62" x 5.86" x 2"';
                    break;
                case "quad_seal_pouch":
                    this.store.data.pouch_size = '3.66" x 11.5" x 2.5"';
                    break;
            }
        },
    }
}
</script>
